import { app } from '../../../../app';

app.component('confirmUpdateRecovery', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-update-recovery.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/confirm-update-recovery/confirm-update-recovery.component.js